import React from 'react';
import './DecorativeCurves.css';

function DecorativeCurves() {
  return (
    <div className="decorative-curves" aria-hidden="true">
      {/* Vertical line running through sections */}
      <svg className="curve-vertical" viewBox="0 0 2 1000" preserveAspectRatio="none">
        <path d="M1 0 L1 1000" stroke="#e0e0e0" strokeWidth="1" fill="none" />
      </svg>

      {/* Curved arc - top right */}
      <svg className="curve-arc-1" viewBox="0 0 200 400" fill="none">
        <path d="M200 0 C200 220, 0 220, 0 400" stroke="#e0e0e0" strokeWidth="1" fill="none" />
      </svg>

      {/* Curved arc - center */}
      <svg className="curve-arc-2" viewBox="0 0 300 300" fill="none">
        <circle cx="150" cy="150" r="140" stroke="#e0e0e0" strokeWidth="1" fill="none" strokeDasharray="4 4" />
      </svg>
    </div>
  );
}

export default DecorativeCurves;
